<template>
  <v-container fluid class="payment-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-payment`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Payment
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-payment'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Payment</p>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="paymenttype"
                        v-model="edit_payment.paymenttype"
                        v-on:change="onChangePayment($event, 'paymenttype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the payment type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_paymentdate"
                        v-model="menu_paymentdate"
                        :close-on-content-click="false"
                        :return-value.sync="paymentdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="paymentdate"
                            label="Payment Date"
                            v-bind="attrs"
                            v-bind:value="paymentdate"
                            v-on:change="
                              onChangePayment($event, 'paymentdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the payment date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="paymentdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_paymentdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangePayment(
                                paymentdate,
                                'paymentdate'
                              );
                              $refs.menu_paymentdate.save(paymentdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        v-if="type=='service'"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_payment.locationid"
                        v-on:change="onChangePayment($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        v-if="type=='service'"
                        class="mb-4"
                        :items="departments.map(x => {return {text: x.departmentname, value: x._id};})"
                        v-model="edit_payment.departmentid"
                        v-on:change="onChangePayment($event, 'departmentid')"
                        v-bind:error="errorindex == 7"
                        outlined
                        dense
                        placeholder="Department"
                        persistent-hint
                        single-line hint="Please choose the department">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...properties.map(x => {return {text: x.propertyname, value: x._id};})
                        ]"
                        v-model="edit_payment.propertyid"
                        v-on:change="onChangePayment($event, 'propertyid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Property"
                        persistent-hint
                        single-line hint="Please choose the property">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...regions.map(x => {return {text: x.regionname, value: x._id};})
                        ]"
                        v-model="edit_payment.regionid"
                        v-on:change="onChangePayment($event, 'regionid')"
                        v-bind:error="errorindex == 7"
                        outlined
                        dense
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Completed']"
                        v-model="edit_payment.paymentstatus"
                        v-on:change="onChangePayment($event, 'paymentstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                      <v-switch
                        color="primary"
                        v-on:change="onChangePayment($event, 'isTaxable')"
                        v-model="edit_payment.isTaxable"
                        v-bind:value="edit_payment ? edit_payment.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="data_accounts"
                        v-model="edit_payment.accountid"
                        v-on:change="onChangePayment($event, 'accountid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Payment From Account"
                        persistent-hint
                        single-line hint="Enter the payment from account">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        v-model="edit_payment.paymentname"
                        v-on:change="
                          onChangePayment($event, 'paymentname')
                        "
                        outlined
                        dense
                        placeholder="Reciver Name"
                        persistent-hint
                        single-line
                        hint="Enter the receiver name"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        v-model="edit_payment.refnum"
                        v-on:change="
                          onChangePayment($event, 'refnum')
                        "
                        outlined
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line
                        hint="Enter the invoice or ref num"
                      >
                      </v-text-field>
                      <v-textarea
                          v-model="edit_payment.paymentnote"
                          v-on:change="onChangePayment($event, 'paymentnote')"
                          outlined
                          rows=1
                          label="Note"
                          hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                        v-on:change="onChangePayment($event, 'primaryCurrency')"
                        v-bind:value="edit_payment.primaryCurrency"
                        v-bind:error="errorindex == 11"
                        outlined
                        dense
                        placeholder="Primary Currency"
                        persistent-hint
                        single-line hint="Please choose the primary currency">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                        v-on:change="onChangePayment($event, 'secondaryCurrency')"
                        v-bind:error="errorindex == 12"
                        v-bind:value="edit_payment.secondaryCurrency"
                        outlined
                        dense
                        placeholder="Secondary Currency"
                        persistent-hint
                        single-line hint="Please choose the secondary currency">
                      </v-select>
                      <v-text-field
                        :readonly="isNotEditable"
                          class="mb-4"
                          v-bind:value="edit_payment.currencyRate"
                          v-bind:error="errorindex == 13"
                          v-on:change="onChangePayment($event, 'currencyRate')"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/payment/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updatePayment()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/payment/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_item"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.itemamount="{ item }">
                          {{ item.itemamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_files"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ delete_file.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(delete_file)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/payment/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass2"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses2
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_item: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      header_files: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      change_payment: {},
      edit_payment: {},
      
      delete_file: {},
      search_vendor: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      upload: {filename: null,file: null},
      files: [],
      paymenttype: ["Payment", "Bank Transfer", ],
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      route: 0,

      type: null,
      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,

      paymentdate: null,
      paymentduedate: null,
      menu_paymentdate: false,
      menu_paymentduedate: false,

      isRental: false,
      isEditTransaction: false,
      isAddTransaction: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Payment", ["isReceiving"]),
    ...mapState("Location", ["locations"]),  
    ...mapState("Department", ["departments"]),
    ...mapState("Property", ["properties"]),  
    ...mapState("Region", ["regions"]),  
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.paymentstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.paymentstatus) >= 0;
      console.log(result);
      return result;
    },
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Accounts Receivable'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
    data_classes(){
      let object = Object.groupBy(this.accounts, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses2(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass2);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("Payment", ["deletePaymentTransactionRequest", "getPaymentsRequest", "insertPaymentTransactionRequest", "updatePaymentRequest", "updatePaymentTransaction"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("Property", ["getPropertiesRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions('SystemSetting', ["getSetting"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.new_transaction.itemamount = this.new_transaction.itemquantity * this.new_transaction.itemprice;
      else if(this.route==1)this.edit_transaction.itemamount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.itemamount = this.edit_transaction.itemamount;  
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.delete_file = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deletePaymentTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getPaymentsRequest();
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({id: this.initvalue._id}, this.new_transaction);
      let response = await this.insertPaymentTransactionRequest(payload);
      this.transactions.push(response);
      this.getPaymentsRequest();
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass2 = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
      this.isEditTransaction = true;
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangePayment(value, field) {
      this.change_payment[field] = value;
    },



    searchVendorDialog(){
      this.search_vendor = {};
      this.isSearchVendor = true;
    },
  
    async updatePayment() {
      this.change_payment._id = this.initvalue._id;
      await this.updatePaymentRequest(this.change_payment);
      router.push("/payment/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updatePaymentTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getPaymentsRequest();
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'payment';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
      this.getPaymentsRequest();
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "PaymentList" });
    this.edit_payment = Object.assign({}, this.initvalue);
    this.paymentdate = formatStdDate(this.initvalue.paymentdate);

    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.departments.length==0) await this.getDepartmentsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.properties.length==0) await this.getPropertiesRequest();
    if (this.regions.length==0) await this.getRegionsRequest();

    this.files = this.initvalue.files;
    this.transactions = Object.assign([], this.initvalue.transactions);
    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
